import React from 'react';
import styled from 'styled-components';

import Invoice from '../../types/invoice';
import InvoiceCardListItem from './InvoiceCardListItem';
import { CardListItem } from './InvoiceCardListItem.styled';

interface Props {
  invoices: Invoice[];
  onPayInvoice: (invoice: Invoice) => void;
}

const InvoiceCardList = ({ invoices, onPayInvoice }: Props) => {
  const cards = invoices.map(invoice => (
    <InvoiceCardListItem
      key={invoice.id}
      invoice={invoice}
      onPayClick={() => onPayInvoice(invoice)}
    />
  ));

  const emptyState = (
    <EmptyStateCard>
      There are currently no invoices on your account.
      <p>
        We will send you an email if there is any financial activity or please check back at a later
        time.
      </p>
    </EmptyStateCard>
  );

  return <CardList>{cards.length === 0 ? emptyState : cards}</CardList>;
};

export default InvoiceCardList;

export const EmptyStateCard = styled(CardListItem)`
  padding: 16px;

  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.night};
  font-size: 13px;
  line-height: 16px;

  p {
    margin-top: 16px;
  }
`;

export const CardList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;
